// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Bhob","actions":"GroupTable_actions__2SeZ0","deleteModalFooter":"GroupTable_deleteModalFooter__1C1ah"};